import React, { useEffect, useState } from "react"
import {
  VerticalTimeline,
  VerticalTimelineElement
} from "react-vertical-timeline-component"
import "./Journey.css"
import "react-vertical-timeline-component/style.min.css";

import axiosClient from "./axiosClient";
import { devlogAPIURL } from "../APIurl";

const Journey = () => {
  const [flag, setFlag] = useState([])
  const [journeyItems, setJourneyItems] = useState([])
  useEffect(() => {
    console.log("here", flag)
  }, [flag])

  
  useEffect( () => {
      
    setTimeout(() => {
     (async function () {
         try {
             const journeyItemsResp = await axiosClient.get(`${devlogAPIURL}/journeyItems`);
             const journeyItems = journeyItemsResp.data;
             const sorted = journeyItems.sort((i, j) => ((i.originalDate)).localeCompare((j.originalDate)) );
             // const sorted = journeyItems.sort((i:any, j:any) => (new Date(i.originalDate)) > (new Date(j.originalDate)) );
             console.log('journeyItems', sorted.map((i) => new Date(i.originalDate)))
             setJourneyItems(sorted);
             const defFlags= [];
             journeyItems.forEach(() => {
                 defFlags.push(false);
             });
             setFlag(defFlags);
         } catch (error) {
             return {
                 error
             };
         }
     })();
    }, 1000);
     
 }, [])


  const setFlagUpdate = (item, i) => {
    flag[i] = !flag[i]
    const newFlag = [
      ...flag.slice(0, i),
      flag[i],
      ...flag.slice(i + 1, flag.length)
    ]
    setFlag(newFlag)
  }

  return (
    <div className="journey-container bg-black-purple">
      <div className="font-larger text-center color-white">
        {" "}
        Mileposts
        {journeyItems.length == 0 ? (
          <h3>Loading... Ruko zara.. Sabar karo..</h3>
        ) : (
          <></>
        )}
      </div>
      <VerticalTimeline className={"vertical-timeline-local"}>
        {journeyItems.map((item, i) => {
          // journeyItems.sort((i:any, j:any) => (new Date(i.originalDate)) < (new Date(j.originalDate)) ).map((item: any, i: any) => {
          return (
            <VerticalTimelineElement
              key={i}
              className="vertical-timeline-element--work"
              contentStyle={{ background: "rgb(37, 107, 205)", color: "#fff" }}
              contentArrowStyle={{
                borderRight: "7px solid  rgb(133, 150, 243)"
              }}
              date={`${item.description}`}
              iconStyle={{
                background: "rgb(6, 24, 68)",
                color: "#fff",
                cursor: "pointer"
              }}
              iconOnClick={() => setFlagUpdate(item, i)}
              icon={
                <div className="journey-icon color-white font-small">Click</div>
              }
            >
              {flag[i] ? (
                <div>
                  <h3 className="vertical-timeline-element-title">
                    {item.header}
                  </h3>
                  <h5 className="vertical-timeline-element-subtitle">
                    {item.description}
                  </h5>
                  <p dangerouslySetInnerHTML={{ __html: item.body }}></p>
                </div>
              ) : (
                <div>
                  <h3 className="vertical-timeline-element-title">
                    {item.header}
                  </h3>
                </div>
              )}
            </VerticalTimelineElement>
          )
        })}
      </VerticalTimeline>
    </div>
  )

  // return <div className="w-container">
  //     <div className="d-flex flex-wrap justify-content-around">
  //         <>
  //             {
  //                 array.map((item, i) => {
  //                     return (item.isVertical) ?
  //                         (<div className="vertical-seperator-end">
  //                             <VerticalSeparator />
  //                         </div>)
  //                         :
  //                         (
  //                             <JourneyItem />
  //                         );
  //                 })
  //             }
  //         </>
  //     </div>
  // {JSON.stringify(array)}

  // </div>;
}

export default Journey
